module.exports = __webpack_public_path__ + "ddf2723be42db16bab63752e6ab5508a.svg";